/* Presentation only. LPO keeps ownership of inputs, order prices and submission. */
(() => {
  // Verified advertised starting quantities; all prices remain owned by LPO.
  const advertisedOffers = {
    'jacquard-knit-socks': 30, 'terry-socks': 30,
    'embroidered-cuffed-beanies-bc045': 10, 'embroidered-cuffed-beanies-bb830n': 10,
    'premium-mesh-trucker-caps': 10, 'printed-snoods': 100,
    'premium-flight-tags': 50, 'embroidered-keyrings': 50, 'printed-lanyards': 50,
    'custom-soft-pvc-keyrings': 50, 'custom-3d-domed-soft-pvc-keyrings': 50,
    'custom-metal-keyrings': 50, 'die-cut-stickers': 50, 'holographic-die-cut-stickers': 50,
    'custom-full-colour-white-mugs': 12, 'black-screen-printed-mugs': 36
  };
  function advertisedQuantity(handle, search) {
    const quantity = advertisedOffers[handle];
    if (!quantity) return null;
    const params = new URLSearchParams(search);
    if (params.has('variant')) return null;
    // Explicit verified offer links must also work without legacy campaign tags.
    if (params.getAll('pp_offer_quantity').length === 1 && params.get('pp_offer_quantity') === String(quantity)) return quantity;
    const campaign = params.get('utm_campaign');
    if (campaign === 'pp_products_sep2026' && handle === 'custom-soft-pvc-keyrings' && params.get('utm_content') === 'pvc_labdesk_reel') return quantity;
    // Keep responsive QA out of paid campaign reporting.
    if (campaign === 'checkout-oct6' && params.get('utm_source') === 'visual-qa' && params.get('utm_medium') === 'quality-check') {
      return params.get('pp_offer_quantity') === String(quantity) ? quantity : null;
    }
    if (!['pp_products_20260922', 'pp_conversion_expansion_20261003'].includes(campaign)) return null;
    return ['A', 'B', 'static', 'video'].some(suffix => params.get('utm_content') === `${handle}_${suffix}`) ? quantity : null;
  }
  function applyLandingQuantity(root, quantity, state) {
    if (!quantity || state.applied || state.interacted) return false;
    const mixed = ['jacquard-knit-socks', 'terry-socks', 'embroidered-cuffed-beanies-bc045', 'embroidered-cuffed-beanies-bb830n', 'premium-mesh-trucker-caps'].includes(root.dataset.productHandle);
    if (mixed && !root.classList.contains('pp-has-mix')) return false;
    if (!root.querySelector('#pp-price-bar') || !root.querySelector('input[name="quantity"]')) return false;
    const input = [...root.querySelectorAll('.pp-tier-item input[type="radio"]')].find(item => Number(item.value) === quantity && !item.disabled);
    if (!input) return false;
    state.applied = true; // Native app events can synchronously trigger another update.
    root.dataset.ppLandingQuantity = String(quantity);
    (mixed ? input.closest('.pp-tier-item') : input).click();
    return true;
  }
  function positionArtwork(pond, intro, bar, target) {
    if (!pond || !target) return;
    // Move out of the app's hidden mount once. Keep one owner for this order so
    // mouse-down targets and keyboard focus survive subsequent app updates.
    if (pond.parentNode !== target) target.insertBefore(pond, target.querySelector('#pp-qty-summary, button[name="add"]'));
    if (intro && pond.previousElementSibling !== intro) pond.before(intro);
    if (bar && pond.nextElementSibling !== bar) pond.after(bar);
  }

  function polishArtworkLabel(label, formatCaption = 'AI, EPS, PDF, SVG, PNG or JPG') {
    const action = label.querySelector('u, .filepond--label-action');
    if (!action || label.querySelector('.pp-upload-picker__copy')) return;
    const make = (tag, className, text) => {
      const element = label.ownerDocument.createElement(tag);
      element.className = className;
      if (text) element.textContent = text;
      return element;
    };
    const icon = make('span', 'pp-upload-picker__icon');
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9H7v33h25v-5" opacity=".4"/><path d="M17 5h16l8 8v24H17z"/><path d="M33 5v9h8M23 25l5-5 5 5M28 20v11"/></svg>';
    const copy = make('span', 'pp-upload-picker__copy');
    copy.append(make('strong', '', 'Add design files'), make('span', '', formatCaption));
    action.textContent = 'Browse files';
    action.classList.add('pp-upload-picker__button');
    label.classList.add('pp-upload-picker');
    // Reuse the app's real action and label. Its file input, listeners, uploaded
    // items, progress and order properties remain owned by FilePond/LPO.
    label.replaceChildren(icon, copy, action);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {polishArtworkLabel, positionArtwork, advertisedQuantity, applyLandingQuantity};
  if (typeof document === 'undefined') return;
  const root = document.querySelector('.pp-product-studio');
  if (!root || root.dataset.studioReady) return;
  root.dataset.studioReady = 'true';
  const landingQuantity = advertisedQuantity(root.dataset.productHandle, window.location.search);
  const landingState = {applied: false, interacted: false};
  const rememberInteraction = event => {
    if (event.isTrusted && event.target.closest('.product-single__form, .pp-pack-form')) landingState.interacted = true;
  };
  ['pointerdown', 'keydown', 'input', 'change'].forEach(type => root.addEventListener(type, rememberInteraction, true));
  const retailStickerPack = root.dataset.ppStickerPackStudio === 'true' && ['budget-die-cut-sticker-packs', 'premium-die-cut-sticker-packs'].includes(root.dataset.productHandle);
  const colourImages = JSON.parse(document.getElementById('pp-colour-image-map')?.textContent || '{}');
  document.body.classList.add('pp-buy-polished');
  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };
  root.querySelector('.product-block--sales-point')?.remove();
  const orderLink = (label, target = '#pp-product-options') => {
    const link = document.createElement('a');
    link.className = 'pp-order-link';
    link.href = target;
    link.textContent = label;
    return link;
  };
  // Keep one H1, positioned before the gallery on smaller screens.
  const heading = root.querySelector('.product-block--header');
  const meta = root.querySelector('.product-single__meta');
  const mainGrid = root.querySelector('.page-width > .grid');
  const mobile = matchMedia('(max-width: 768px)');
  const facts = heading?.querySelector('.pp-order-facts');
  const factsHome = facts ? document.createComment('Order facts desktop position') : null;
  if (factsHome) facts.before(factsHome);
  const positionHeading = () => {
    if (!heading || !meta || !mainGrid) return;
    if (mobile.matches) {
      mainGrid.prepend(heading);
      // Show the product sooner; retain the same facts beside the order controls.
      if (facts) meta.prepend(facts);
    } else {
      meta.prepend(heading);
      if (factsHome) factsHome.after(facts);
    }
  };
  positionHeading();
  mobile.addEventListener('change', positionHeading);
  const blocks = root.querySelector('[data-product-blocks]');
  if (blocks) blocks.id = 'pp-product-options';
  if (heading && blocks) {
    const shortcut = orderLink('Choose quantity and customise ↓');
    shortcut.classList.add('pp-mobile-order-shortcut');
    heading.append(shortcut);
  }
  document.querySelectorAll('.pp-tl__trust-cta, .pp-mcta__pill').forEach(link => {
    link.href = '#pp-product-options';
    link.removeAttribute('onclick');
  });
  const gallery = root.querySelector('.pp-native-stacked-wrapper');
  const count = root.querySelectorAll('[data-product-thumb]').length;
  if (gallery && count) {
    const note = document.createElement('div');
    note.className = 'pp-buy-gallery-note';
    const caption = document.createElement('span');
    caption.className = 'pp-gallery-position';
    const thumbs = [...root.querySelectorAll('[data-product-thumb]')];
    const controls = document.createElement('div');
    controls.className = 'pp-gallery-controls';
    const currentIndex = () => Math.max(0, thumbs.findIndex(thumb => thumb.classList.contains('is-active')));
    const buttons = [-1, 1].map(direction => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = direction < 0 ? '←' : '→';
      button.setAttribute('aria-label', direction < 0 ? 'Previous product photo' : 'Next product photo');
      button.addEventListener('click', () => {
        const next = thumbs[currentIndex() + direction];
        if (next) next.click();
      });
      return button;
    });
    const updatePosition = () => {
      const index = currentIndex();
      setText(caption, `${String(index + 1).padStart(2, '0')} / ${String(count).padStart(2, '0')}`);
      buttons[0].disabled = index === 0;
      buttons[1].disabled = index === count - 1;
    };
    controls.append(buttons[0], caption, buttons[1]);
    note.append(orderLink('Make it yours ↓'), controls);
    gallery.append(note);
    updatePosition();
    new MutationObserver(updatePosition).observe(root.querySelector('.product__thumbs'), { attributes: true, subtree: true, attributeFilter: ['class'] });
  }
  root.querySelectorAll('.js-photoswipe__zoom').forEach(button => button.setAttribute('aria-label', 'Enlarge product photo'));
  const help = document.createElement('div');
  help.className = 'pp-buy-help';
  const delivery = document.createElement('span');
  delivery.textContent = 'Free UK tracked delivery. Production time applies.';
  const contact = document.createElement('a');
  contact.href = `/pages/contact?product=${encodeURIComponent(root.dataset.productTitle)}`;
  contact.textContent = 'Need help?';
  help.append(delivery, contact);
  root.querySelector('.product-single__form')?.append(help);

  // Retain product-specific copy in accessible native disclosures, without a
  // second long sales pitch between the photos and the ordering information.
  const disclosure = (label, nodes, destination) => {
    if (!nodes.length || !destination) return;
    const details = document.createElement('details');
    details.className = 'pp-product-more';
    const summary = document.createElement('summary');
    summary.textContent = label;
    details.append(summary, ...nodes);
    destination.append(details);
    return details;
  };
  const whyText = document.querySelector('.pp-wc__text .metafield-rich_text_field') || document.querySelector('.pp-wc__text');
  if (whyText?.children.length > 1) {
    disclosure('More about this product', [...whyText.children].slice(1), whyText);
  }
  const whyContent = document.querySelector('.pp-wc__content');
  if (whyContent) whyContent.append(orderLink('Create your own →'));
  const detailText = document.querySelector('.pp-dgal__text');
  if (detailText) disclosure('Read the full specifications', [...detailText.children], detailText);
  const detailSplit = document.querySelector('.pp-dgal__split');
  const finishCopy = document.querySelector('.pp-finish__copy');
  if (detailText && finishCopy) {
    disclosure('Materials and finish', [...finishCopy.children], detailText);
    document.querySelector('.pp-finish').hidden = true;
  }
  const ideal = document.querySelector('.pp-ideal');
  if (ideal && detailText) {
    const idealContent = [...ideal.querySelector('.pp-ideal__inner').children].filter(node => !node.classList.contains('pp-ideal__header'));
    disclosure('Who this product is for', idealContent, detailText);
    ideal.hidden = true;
  }
  if (detailSplit) detailSplit.after(orderLink('Choose your quantity and customise →'));
  document.querySelectorAll('.pp-art__item[open]').forEach(item => { item.open = false; });
  document.querySelector('.pp-art__header')?.append(orderLink('Upload your artwork ↑', '#pp-product-upload'));

  // Only link sections that this product actually has. Native anchors work with
  // the existing content and keep the page's browser history and keyboard flow.
  const nav = document.createElement('nav');
  nav.className = 'pp-product-nav';
  nav.setAttribute('aria-label', 'Explore this product');
  [
    ['.pp-dgal', 'details', 'Product details'],
    ['.pp-dgal__grid', 'photos', 'Photos'],
    ['.pp-art', 'artwork', 'Artwork guide'],
    ['.pp-art-templates', 'templates', 'Templates'],
    ['.pp-tl', 'production', 'Production'],
    ['.pp-pfaq', 'questions', 'FAQs'],
    ['.pp-product-reviews', 'reviews', 'Customer reviews']
  ].forEach(([selector, key, label]) => {
    const target = document.querySelector(`#MainContent ${selector}`);
    if (!target) return;
    if (!target.id) target.id = `pp-product-${key}`;
    target.classList.add('pp-product-anchor');
    const link = document.createElement('a');
    link.href = `#${target.id}`;
    link.textContent = label;
    nav.append(link);
  });
  if (nav.children.length) {
    const motionControl = document.querySelector('.pp-space-toggle');
    if (motionControl) nav.append(motionControl);
    root.after(nav);
  }

  const detailGallery = document.querySelector('#MainContent .pp-dgal__grid');
  document.querySelectorAll('[data-product-story-gallery]').forEach((story, index) => {
    if (window.theme?.Photoswipe) new window.theme.Photoswipe(story, `pp-story-${index}`);
  });
  const photos = detailGallery?.querySelectorAll('.pp-dgal__item');
  if (detailGallery && window.theme?.Photoswipe) new window.theme.Photoswipe(detailGallery, 'pp-details');
  if (photos?.length > 1) {
    detailGallery.tabIndex = 0;
    detailGallery.setAttribute('role', 'region');
    detailGallery.setAttribute('aria-label', 'Product detail photos');
    const caption = detailGallery.querySelector('.pp-dgal__meta-caption');
    if (caption) detailGallery.after(caption);
    const toolbar = document.createElement('div');
    toolbar.className = 'pp-product-gallery-tools';
    const photoCount = document.createElement('span');
    photoCount.textContent = `${photos.length} detail photos`;
    toolbar.append(photoCount);
    const controls = document.createElement('div');
    const buttons = [-1, 1].map(direction => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = direction === -1 ? '←' : '→';
      button.setAttribute('aria-label', direction === -1 ? 'Previous detail photos' : 'Next detail photos');
      button.setAttribute('aria-controls', detailGallery.id);
      button.addEventListener('click', () => {
        const step = photos[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(detailGallery).gap) || 0);
        detailGallery.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
      controls.append(button);
      return button;
    });
    toolbar.append(controls);
    const galleryHeader = detailGallery.parentElement.querySelector('.pp-dgal__header');
    if (galleryHeader) galleryHeader.after(toolbar, detailGallery);
    else detailGallery.before(toolbar);
    if (caption) detailGallery.after(caption);
    const updateGallery = () => {
      const maximum = detailGallery.scrollWidth - detailGallery.clientWidth;
      controls.hidden = maximum < 2;
      buttons[0].disabled = detailGallery.scrollLeft < 2;
      buttons[1].disabled = detailGallery.scrollLeft >= maximum - 2;
    };
    detailGallery.addEventListener('scroll', updateGallery, { passive: true });
    new ResizeObserver(updateGallery).observe(detailGallery);
    updateGallery();
  }
  // These are navigation aids, not production colour specifications. The actual
  // supplier photo stays available beside the palette, including on touch screens.
  const colours = {
    white:'#f5f4ee',yellow:'#edcc28',peach:'#eab39d',petrol:'#295763',plum:'#62394d',pumpkin:'#c16b37',purple:'#56336d',rose:'#b87578',rust:'#a35336',sand:'#c3b694',
    'sapphire blue':'#196ea3','sky blue':'#9dcada','soft white':'#e8e2d4',sunset:'#cc826f','surf blue':'#3b91ac',teal:'#25666e','true pink':'#df8db5',violet:'#8a69a5',walnut:'#6e5544',
    'lime green':'#8ea744',magenta:'#ad3165','marine green':'#31514c',mint:'#a5c5b6','moss green':'#67724f',mustard:'#b2953f','natural stone':'#bcb5a3',olive:'#73704d',orange:'#e87931',
    'oxford navy':'#272b3a','pastel pink':'#e0c1c7','french navy':'#202735',fuchsia:'#c22b77',gold:'#d6af37',granite:'#727572','graphite grey':'#484a4a','heather grey':'#939592',
    'heather navy':'#465463','heather oatmeal':'#c1b9a4','heather surf blue':'#779da9','kelly green':'#328757',lavender:'#b0a4c5','light grey':'#bdbfba',coral:'#d68278','dusty pink':'#b58f94',
    'dusty blue':'#809baa','dusty green':'#93a694','dusty purple':'#998997',emerald:'#377960','festival fuchsia':'#cd4880','fire red':'#b72c30','fluorescent green':'#a7d941',
    'fluorescent orange':'#ef7d2c','fluorescent pink':'#ec5688','fluorescent yellow':'#d9e943','ash grey':'#b9bdb7',biscuit:'#b19a75',black:'#202123',blush:'#d5b0a4','bottle green':'#293f35',
    'bright red':'#ca3337','bright royal blue':'#2c5092',burgundy:'#66333f',caramel:'#ad784d',charcoal:'#454646',chocolate:'#574438','classic pink':'#d3a8ba','classic red':'#ae2939',
    'cloud grey':'#acb1b2','airforce blue':'#546e81',almond:'#c2b9a3','antique grey':'#727874','off white':'#e7e1d2','olive green':'#6a6c48',buck:'#7f805c','dark grey':'#515358',
    cranberry:'#813441','dark navy':'#232b3b',evergreen:'#365647',khaki:'#b6a786',maroon:'#683440','light navy':'#3e5574',moss:'#6b6e45',navy:'#2c3b50',pink:'#d8a1af',silver:'#a8aaaa',red:'#bd343e','steel grey':'#787a7b'
  };
  // Product-specific silhouettes: original hardware references and approved job photos.
  const strap = '<path fill="#d4ff46" fill-opacity=".16" stroke="#d4ff46" d="M27 4h18v17H27zM31 8v9m5-9v9m5-9v9"/>';
  const clip = '<path d="M26 18c-5 0-7 3-7 6s3 6 8 6h18c5 0 8-3 8-6s-2-6-7-6M32 30v5h8v-5"/><path d="M29 35h14v9l-4 17c-2 7-14 8-17 1-2-4-1-8 2-11l5-5V35Z"/><path d="m29 46-6 11m17-14 7 9-3 3-4-5M25 55l-3 4"/><circle cx="36" cy="41" r="2"/>';
  const sock = '<path fill="currentColor" fill-opacity=".04" d="M29 4h19v32c0 7-3 12-9 16L24 63c-5 4-12 2-14-3-3-5-1-10 4-13l15-10V4Z"/><path stroke="#d4ff46" d="M29 4h19v9H29zM33 5v7m5-7v7m5-7v7"/><path d="M33 17v15m5-15v15m5-15v15M39 36c-1 7 2 10 5 10M12 48c6 0 11 5 12 14"/><path stroke="#d4ff46" d="m14 55 3 4m2-7 3 4"/>';
  const sockPair = '<g opacity=".4" transform="translate(-5 0) scale(.9)">' + sock + '</g><g transform="translate(13 7) scale(.9)">' + sock + '</g>';
  const optionIcons = {
    'sock-small': '<g transform="translate(5 8) scale(.86)">' + sockPair + '</g>',
    'sock-medium': '<g transform="translate(2.5 4) scale(.93)">' + sockPair + '</g>',
    'sock-large': sockPair,
    'Standard-Metal-Clip': strap + '<g fill="#e4e7e6" fill-opacity=".3">' + clip + '</g>',
    'Standard-Black-Metal-Clip': strap + '<g fill="#17191c" stroke="#aeb3b7">' + clip + '</g>',
    'Premium-Metal-Clip': strap + '<path d="M26 18c-7 0-10 5-7 10l7 6m20-16c7 0 10 5 7 10l-7 6"/><path fill="currentColor" fill-opacity=".18" d="M29 29c5-4 13-3 16 3s1 11-1 17l-4 12c-3 8-15 8-19 1-2-4-1-9 2-13l8-10c4-5 5-7-2-10Z"/><path d="M31 39 23 52m1-4 3 3M29 58c2 4 6 4 8 0l4-13"/><circle cx="39" cy="35" r="2"/>',
    'Safety-Break-Away': '<path fill="#d4ff46" fill-opacity=".1" stroke="#d4ff46" d="M29 6 8 58l9 8 46-19-4-11-40 20L36 10zM35 7l10 11m11 14 7 9"/><g transform="rotate(-43 48 24)"><path fill="#25262b" d="M40 9h16v13H40zM40 25h16v14H40z"/><path d="M43 13h10m-10 22h10M43 22v3m10-3v3"/></g>',
    'Plastic-Buckle': '<path fill="#d4ff46" fill-opacity=".16" stroke="#d4ff46" d="M28 3h16v11H28zm0 56h16v13H28z"/><path fill="#25262b" d="M24 12h24v7H24zM25 19v15l4 4 2-14m10 0 2 14 4-4V19M34 20h4v16h-4zM23 45h26v8l-5 7H28l-5-7z"/><path d="M28 50h16m-16 5h16"/>',
    chain: '<circle cx="32" cy="23" r="17" fill="#17191c" stroke="#b8bdc1"/><circle cx="32" cy="23" r="12"/><path d="M44 29 48 32M43 32l4 3"/><g fill="#17191c"><ellipse cx="32" cy="41" rx="3" ry="6"/><ellipse cx="35" cy="49" rx="5" ry="3" transform="rotate(65 35 49)"/><ellipse cx="39" cy="56" rx="3" ry="5"/><ellipse cx="41" cy="63" rx="5" ry="3"/></g>',
    loop: '<g transform="rotate(-18 36 36)"><path fill="currentColor" fill-opacity=".035" d="M31 26h29v35H31z"/><path stroke="#d4ff46" stroke-dasharray="2 3" d="M35 31h21v25H35z"/><circle cx="38" cy="37" r="5"/><ellipse cx="25" cy="28" rx="17" ry="13" fill="#17191c" stroke="#b8bdc1"/><ellipse cx="25" cy="28" rx="12" ry="8"/><path d="m37 31 4 2m-6 1 4 3"/></g>',
    reverse: '<circle cx="35" cy="16" r="10"/><path d="M35 23v10"/><path fill="currentColor" fill-opacity=".04" d="M29 33v-3a6 6 0 0 1 12 0v3a18 18 0 1 1-12 0Z"/><circle cx="35" cy="33" r="2"/><g stroke="#d4ff46"><path d="M26 44h18v14H26zM30 48h10m-10 5h7M55 31c5 5 5 12 2 17m-3-5 3 5 5-3"/></g>',
    packaging: '<path fill="currentColor" fill-opacity=".025" d="M16 19h40v47H16z"/><path fill="#d4ff46" fill-opacity=".14" stroke="#d4ff46" d="M14 6h44v15H14zM24 11h24m-18 5h12"/><circle cx="36" cy="32" r="7"/><path d="M36 37v6"/><path d="M31 44v-3h10v3a9 9 0 1 1-10 0Z"/><path opacity=".5" d="m19 27 6 5m23 23 5 8M20 61l4-4"/>',
    sleeve: '<path fill="currentColor" fill-opacity=".04" d="M22 6h27v12l5 30c2 9-4 16-13 16H29c-8 0-13-7-12-15l5-31V6Z"/><path d="M22 16h27M27 8v7m5-7v7m5-7v7m5-7v7M25 56c6-5 17-5 24 0M30 19l-2 9m16-9 2 9"/><path fill="#d4ff46" fill-opacity=".12" stroke="#d4ff46" d="M17 29h36v20H17zM24 35h22m-17 7h12"/>'
  };
  // Size references copied from the merchant's existing option illustrations.
  // Keep the legacy 10-12K value: it is an order/configuration key, not display copy.
  const sizeOptions = {
    '5-7UK': {icon: 'sock-small', uk: '5 to 7', eu: '36 to 40', us: '5 to 8'},
    '7-10UK': {icon: 'sock-medium', uk: '7 to 10', eu: '40 to 44', us: '8 to 11'},
    '10-12K': {icon: 'sock-large', uk: '10 to 12', eu: '44 to 48', us: '11 to 14'}
  };
  const drawOptionIcon = key => {
    const svg = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">${optionIcons[key]}</svg>`, 'image/svg+xml').documentElement;
    svg.setAttribute('aria-hidden', 'true');
    svg.dataset.ppIcon = key;
    svg.classList.add('pp-option-icon');
    return svg;
  };
  const resetSwatchLayout = option => {
    option.querySelector('.cl-po--swatch-container').removeAttribute('style');
    option.querySelectorAll('.cl-po--swatch-item').forEach(item => item.removeAttribute('style'));
  };
  const colourRefreshers = new WeakMap();
  const enhanceOptions = () => {
    root.querySelectorAll('.cl-po--option[data-option="Choose Your Size"]:not(.pp-size-option)').forEach(option => {
      const items = [...option.querySelectorAll('.cl-po--swatch-item')];
      if (!items.length || !items.every(item => sizeOptions[item.querySelector('input')?.value] && item.querySelector('.cl-po--swatch'))) return;
      option.classList.add('pp-size-option');
      resetSwatchLayout(option);
      items.forEach(item => {
        item.classList.add('pp-option-card');
        const input = item.querySelector('input');
        const size = sizeOptions[input.value];
        const visual = item.querySelector('.cl-po--swatch');
        visual.classList.add('pp-size-visual');
        visual.append(drawOptionIcon(size.icon));
        const copy = document.createElement('span');
        copy.className = 'pp-size-copy';
        const range = text => text.replace(' to ', '–');
        copy.innerHTML = `<strong><small>UK</small> ${range(size.uk)}</strong><span>EU ${range(size.eu)}</span><span>US ${range(size.us)}</span>`;
        item.append(copy);
        input.setAttribute('aria-label', `UK ${size.uk}, EU ${size.eu}, US ${size.us}`);
      });
    });
    root.querySelectorAll('.cl-po--option[data-option="Hardware Selection"]:not(.pp-hardware-option)').forEach(option => {
      const items = [...option.querySelectorAll('.cl-po--swatch-item')];
      if (!items.length) return;
      option.classList.add('pp-hardware-option');
      if (root.dataset.productHandle === 'printed-lanyards') {
        const note = document.createElement('p');
        note.className = 'pp-hardware-required-note';
        note.id = 'pp-hardware-required-note';
        note.textContent = 'Choose at least one fitting before adding to basket. Standard Metal Clip has no extra charge.';
        const heading = option.querySelector('.cl-po--label');
        if (heading) heading.after(note); else option.prepend(note);
        items.forEach(item => {
          const input = item.querySelector('input');
          if (input) input.setAttribute('aria-describedby', [input.getAttribute('aria-describedby'), note.id].filter(Boolean).join(' '));
        });
      }
      resetSwatchLayout(option);
      items.forEach(item => {
        const input = item.querySelector('input');
        const visual = item.querySelector('.cl-po--swatch');
        if (!input || !visual || !optionIcons[input.value]) return;
        item.classList.add('pp-option-card');
        visual.append(drawOptionIcon(input.value));
        visual.classList.add('pp-hardware-visual');
        // Keep the app's visible name and surcharge text intact for its price updater.
        input.setAttribute('aria-label', item.querySelector('.visually-hidden')?.textContent.trim() || input.value);
      });
    });
    root.querySelectorAll('.pp-hardware-option .pp-option-card').forEach(item => {
      const label = item.querySelector('.visually-hidden')?.textContent.trim();
      if (!label) return;
      let copy = item.querySelector('.pp-hardware-copy');
      if (!copy) {
        copy = document.createElement('span');
        copy.className = 'pp-hardware-copy pp-addon-row';
        copy.innerHTML = '<span class="pp-addon-name"></span><span class="pp-addon-price"></span>';
        item.append(copy);
      }
      const price = label.match(/\s*\(\+\s*([^)]*)\)$/);
      setText(copy.querySelector('.pp-addon-name'), price ? label.slice(0, price.index) : label);
      setText(copy.querySelector('.pp-addon-price'), price ? `+${price[1]} / unit` : 'No extra charge');
    });
    root.querySelectorAll('.cl-po--checkbox-item:not(.pp-extra-illustrated)').forEach(item => {
      const option = item.closest('[data-option]');
      const group = option?.dataset.option;
      const key = ({_BlackMetalHardwareUpgrade:root.dataset.productHandle === 'embroidered-keyrings' ? 'loop' : 'chain',_RearPrint1Colour:'reverse',_CustomPackaging:'packaging',Add_Custom_Packaging:'sleeve'})[group];
      if (!key) return;
      option.classList.add('pp-extra-option');
      option.parentElement.classList.add('pp-options-with-extras');
      item.classList.add('pp-extra-illustrated', 'pp-option-card');
      item.prepend(drawOptionIcon(key));
    });
    root.querySelectorAll('.cl-po--option[data-option="Choose Your Colours"]:not(.pp-colour-option)').forEach(option => {
      const container = option.querySelector('.cl-po--swatch-container');
      const items = [...option.querySelectorAll('.cl-po--swatch-item')];
      if (!items.length) return;
      option.classList.add('pp-colour-option');
      resetSwatchLayout(option);
      const make = (tag, className, text) => {
        const el = document.createElement(tag);
        el.className = className;
        if (text) el.textContent = text;
        return el;
      };
      const preview = make('div', 'pp-colour-preview');
      const photo = make('img', 'pp-colour-preview__image');
      photo.decoding = 'async';
      const copy = make('div', 'pp-colour-preview__copy');
      const name = make('strong', 'pp-colour-preview__name');
      const state = make('span', 'pp-colour-preview__state');
      copy.append(make('span', 'pp-colour-preview__eyebrow', 'Colour preview'), name, state, make('span', 'pp-colour-preview__hint', 'Hover or focus to preview. Tap to select.'));
      preview.append(photo, copy);
      container.before(preview);
      const summary = make('p', 'pp-colour-selection');
      summary.setAttribute('aria-live', 'polite');
      const note = make('p', 'pp-colour-note', 'Colours shown are a guide. Check the product photo for the finish.');
      container.after(summary, note);
      let activeItem;
      const show = item => {
        const input = item.querySelector('input');
        const source = item.querySelector('.cl-po--swatch img');
        if (!input || !source) return;
        activeItem = item;
        if (photo.getAttribute('src') !== source.getAttribute('src')) photo.src = source.src;
        photo.alt = `${root.dataset.productTitle} in ${input.value.trim()}`;
        setText(name, input.value.trim());
        setText(state, input.checked ? 'Selected for your order' : 'Preview only');
        preview.classList.toggle('is-selected', input.checked);
      };
      const selection = () => {
        const chosen = items.filter(item => item.querySelector('input')?.checked);
        setText(summary, chosen.length ? `Selected: ${chosen.map(item => item.querySelector('input').value.trim()).join(', ')}` : 'Select the colours for your order.');
        if (activeItem) show(activeItem);
      };
      items.forEach(item => {
        const input = item.querySelector('input');
        const visual = item.querySelector('.cl-po--swatch');
        if (!input || !visual) return;
        const originalPhoto = visual.querySelector('img');
        const thumbnail = originalPhoto && colourImages[decodeURI(originalPhoto.src)];
        if (thumbnail) { originalPhoto.src = thumbnail; originalPhoto.removeAttribute('srcset'); }
        const parts = input.value.trim().toLowerCase().split(/\s*\/\s*/).map(part => colours[part]);
        if (parts.every(Boolean)) {
          visual.classList.add('pp-colour-chip');
          visual.style.setProperty('--pp-colour-a', parts[0]);
          visual.style.setProperty('--pp-colour-b', parts[1] || parts[0]);
          if (/heather|antique/.test(input.value.toLowerCase())) visual.classList.add('pp-colour-chip--heather');
        }
        input.setAttribute('aria-label', input.value.trim());
        item.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') show(item); });
        item.addEventListener('focusin', () => show(item));
      });
      option.addEventListener('change', event => {
        const item = event.target.closest('.cl-po--swatch-item');
        if (item) { show(item); selection(); }
      });
      if (items.length > 12) {
        option.classList.add('pp-colour-option--many');
        const search = make('input', 'pp-colour-search');
        search.type = 'search';
        search.placeholder = `Find a colour (${items.length} available)`;
        search.setAttribute('aria-label', 'Find a colour');
        search.autocomplete = 'off';
        search.addEventListener('keydown', event => {
          if (event.key === 'Enter') event.preventDefault();
        });
        const empty = make('p', 'pp-colour-empty', 'No matching colours. Try another name.');
        empty.hidden = true;
        search.addEventListener('input', () => {
          const query = search.value.trim().toLowerCase();
          let visible = 0;
          items.forEach(item => {
            const match = item.querySelector('input').value.toLowerCase().includes(query);
            item.hidden = !match;
            if (match) visible++;
          });
          empty.hidden = visible > 0;
          if (visible && activeItem?.hidden) {
            show(items.find(item => !item.hidden && item.querySelector('input').checked) || items.find(item => !item.hidden));
          }
        });
        container.before(search, empty);
      }
      show(items.find(item => item.querySelector('input')?.checked) || items[0]);
      selection();
      colourRefreshers.set(option, selection);
    });
    root.querySelectorAll('.pp-colour-option').forEach(option => colourRefreshers.get(option)?.());
  };
  const update = () => {
    enhanceOptions();
    applyLandingQuantity(root, landingQuantity, landingState);
    const addText = root.querySelector('[data-add-to-cart-text]');
    if (addText?.textContent.trim() === 'Add to cart') {
      setText(addText, 'Add to basket');
      addText.dataset.defaultText = 'Add to basket';
    }
    if (root.dataset.productHandle === 'printed-lanyards' && addText && !/sold out|unavailable|adding|added/i.test(addText.textContent) && !addText.closest('button')?.classList.contains('btn--loading')) {
      const fittings = root.querySelector('.pp-hardware-option');
      if (fittings) {
        const caption = fittings.querySelector('input:checked') ? 'Add to basket' : 'Choose your fittings';
        setText(addText, caption);
        addText.dataset.defaultText = caption;
      }
    }
    const pond = root.querySelector('[data-pp-artwork], .filepond--root');
    if (pond && !pond.dataset.ppUploadPolished) {
      pond.dataset.ppUploadPolished = 'true';
      pond.id = 'pp-product-upload';
      pond.classList.add('pp-product-anchor', 'pp-upload-attachment');
      const intro = document.createElement('div');
      intro.className = 'pp-upload-intro';
      const title = document.createElement('strong');
      title.textContent = 'Your artwork';
      const guide = document.createElement('a');
      guide.href = '#pp-product-artwork';
      guide.textContent = 'Artwork help';
      intro.append(title, guide);
      if (retailStickerPack) title.textContent = 'Your sticker and packaging artwork';
      if (document.getElementById('pp-product-templates')) {
        const templates = document.createElement('a');
        templates.href = '#pp-product-templates';
        templates.textContent = 'Templates';
        intro.append(templates);
      }
      if (['die-cut-stickers', 'holographic-die-cut-stickers'].includes(root.dataset.productHandle)) {
        const process = document.createElement('span');
        process.className = 'pp-upload-intro__note';
        process.textContent = 'Upload now for an instant proof, or email your artwork with your order number after checkout. Approval is required before production.';
        intro.append(process);
      } else if (!retailStickerPack) {
        const process = document.createElement('span');
        process.className = 'pp-upload-intro__note';
        process.textContent = 'Upload your design here. We check your artwork before production.';
        intro.append(process);
      }
      pond.before(intro);
    }
    const uploadIntro = root.querySelector('.pp-upload-intro');
    const bar = root.querySelector('#pp-price-bar');
    positionArtwork(pond, uploadIntro, bar, root.querySelector('.payment-buttons'));
    const uploadLabel = pond?.querySelector('.filepond--drop-label label');
    if (uploadLabel) polishArtworkLabel(uploadLabel, root.dataset.productHandle === 'die-cut-stickers' || root.dataset.productHandle === 'holographic-die-cut-stickers' ? 'PNG, JPG, WebP, GIF or PDF · one design at a time' : undefined);
    root.querySelectorAll('.cl-po--swatch-item input').forEach(input => {
      if (!input.hasAttribute('aria-label')) input.setAttribute('aria-label', input.value);
    });
    const extras = root.querySelector('.pp-addon-header');
    if (extras && extras.textContent !== 'Optional extras') extras.textContent = 'Optional extras';
    if (!bar) return;
    const header = bar.querySelector('.pp-price-bar__header');
    if (header && header.textContent !== 'Order total') header.textContent = 'Order total';
    const turnaround = bar.querySelector('.pp-price-bar__prod-value');
    setText(turnaround, turnaround?.textContent.replace(/(\d)\s*[-–—]\s*(\d)/g, '$1 to $2').toLowerCase());
    // Expose the existing configured total, not the underlying placeholder variant.
    const total = bar.querySelector('#pp-total-price');
    const amount = Number(total?.textContent.replace(/[^\d.]/g, ''));
    bar.classList.toggle('pp-price-ready', amount > 0);
    if (total && !total.hasAttribute('aria-live')) {
      total.setAttribute('aria-live', 'polite');
      total.setAttribute('aria-atomic', 'true');
    }
    const stickyPrice = document.querySelector('.pp-sticky-bar__price');
    if (amount > 0 && !root.classList.contains('pp-vat-ready')) setText(stickyPrice, `${total.textContent} ex VAT · ${bar.querySelector('#pp-run-qty')?.textContent.toLowerCase() || ''}`);
    window.PPVat?.updateProduct(root);
    if (root.dataset.ppOrderValid === 'false') setText(stickyPrice, 'Choose quantities to see your total');
    if (root.classList.contains('pp-order-editor') && addText && !addText.closest('button')?.classList.contains('btn--loading') && !/sold out|unavailable|adding|added/i.test(addText.textContent)) {
      const quantity = Number(root.dataset.ppMixedTotal) || 0;
      const caption = root.dataset.ppOrderValid === 'true' ? `Add ${quantity} ${root.dataset.ppOrderNoun} to basket` : quantity ? 'Check your quantities' : root.dataset.ppMixedKind === 'size' ? 'Choose your sizes' : 'Choose your colours';
      setText(addText, caption);
      addText.dataset.defaultText = caption;
    }
  };
  update();
  let updateFrame;
  const scheduleUpdate = () => {
    if (updateFrame) return;
    updateFrame = requestAnimationFrame(() => { updateFrame = null; update(); });
  };
  // File upload progress and pricing can both change several nodes in one frame.
  const observer = new MutationObserver(scheduleUpdate);
  const form = root.querySelector('.product-single__form, .pp-pack-form');
  if (form) {
    observer.observe(form, { childList: true, subtree: true });
    form.addEventListener('reset', scheduleUpdate);
    form.addEventListener('change', scheduleUpdate);
  }
})();
